import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";

import InventoryEmployees from "@containers/Inventory/EmployeeList";
import InventoryEmployeeDetails from "@containers/Inventory/EmployeeDetails";

import ProcurementsList from "@containers/Inventory/ProcurementsList";
import ProcurementsListTabs from "@containers/Inventory/ProcurementListTabs";
import InventoryRoomConfiguration from "@containers/Inventory/RoomConfiguration";
import Settings from "@containers/Inventory/Settings";
import CreateProcurements from "@containers/Inventory/CreateProcurements";
import ProcurementsDetails from "@containers/Inventory/ProcurementsDetails";
import CreateProductBatch from "@containers/Inventory/CreateProductBatch";
import ForecastingList from "@containers/Inventory/ForecastingList";

import NoMatch from "@containers/no-match";

import RequisitionList from "@containers/Inventory/RequisitionList";
import CreateRequisition from "@containers/Inventory/CreateRequisition";
import RequisitionDetails from "@containers/Inventory/RequisitionDetails";
import Warranty from "@containers/Inventory/Warranty";
import Maintenance from "@containers/Inventory/Maintenance";
import CreateMaintenance from "@containers/Inventory/CreateMaintenance";
import SoftwareInventory from "@containers/Inventory/SoftwareInventory";
import SoftwareInventoryForm from "@containers/Inventory/SoftwareInventoryForm";
import MaintenanceDetails from "@containers/Inventory/MaintenanceDetails";
import Stock from "@containers/Inventory/Stock";
import RoomConference from "@containers/Inventory/RoomConference";
import CreateRoomConference from "@containers/Inventory/CreateRoomConference";
import RoomConferenceDetails from "@containers/Inventory/RoomConferenceDetails";
import AnnualBudgetPlan from "@containers/Inventory/AnnualBudgetPlan";
import AnnualBudgetPlanDetails from "@containers/Inventory/AnnualBudgetPlanDetails";
import AddNewPackage from "@containers/Inventory/AddNewPackage";
import AddNewAnnualBudgetPlan from "@containers/Inventory/AddNewAnnualBudgetPlan";
import ProductDetails from "@containers/Inventory/ProcurementsDetails/components/ProductDetails";
import StockProductListDetails from "@containers/Inventory/StockProductListDetails";

const { INVENTORY, CREATE, DETAILS, BATCH_CREATE, ID, ID_2 } = ROUTES;
const {
  EMPLOYEES,
  STOCK,
  PROCUREMENTS,
  SETTINGS,
  ROOM_CONFIGURATION,
  CONFERENCE_ROOM,
  BUDGET,
  FORECASTING,
  REQUISITION,
  WARRANTY,
  MAINTENANCE,
  SOFTWARE_INVENTORY,
  PRODUCTS,
} = INVENTORY;

export const InventoryRoutes: RouteType[] = [
  // EMPLOYEE MODULE
  {
    id: "employee_module",
    path: EMPLOYEES,
    children: [
      {
        id: "employee_list",
        index: true,
        element: <InventoryEmployees />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_EMPLOYEE_PAGE",
        },
      },
      {
        id: "employee_details",
        path: ID,
        element: <InventoryEmployeeDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_EMPLOYEE_PAGE",
        },
      },
    ],
  },

  // !!! see after tomorrow

  {
    id: "register_procurement_module",
    path: PROCUREMENTS,
    children: [
      {
        id: "procurement_list",
        index: true,
        element: <ProcurementsListTabs />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
      {
        id: "procurement_create",
        path: CREATE,
        element: <CreateProcurements />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
      {
        id: "procurement_batch_create",
        path: BATCH_CREATE,
        element: <CreateProductBatch />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
      {
        id: "procurement_details",
        path: ID,
        element: <ProcurementsDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
      {
        id: "product_add",
        path: `${ID}/${CREATE}${PRODUCTS}`,
        element: <ProductDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
      {
        id: "product_details",
        path: `${ID}/${ID_2}`,
        element: <ProductDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
    ],
  },

  // STOCK MODULE
  {
    id: "stock",
    path: STOCK,
    children: [
      {
        id: "stock_list",
        index: true,
        element: <Stock />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_STOCK_PAGE",
        },
      },
      {
        id: "stock-details",
        path: ID,
        element: <StockProductListDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  // PROCUREMENT MODULE

  {
    id: "register_procurement_module",
    path: PROCUREMENTS,
    children: [
      {
        id: "procurement_list",
        index: true,
        element: <ProcurementsList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
      {
        id: "procurement_create",
        path: CREATE,
        element: <CreateProcurements />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },

      {
        id: "procurement_batch_create",
        path: BATCH_CREATE,
        element: <CreateProductBatch />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },

      {
        id: "procurement_details",
        path: ID,
        element: <ProcurementsDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_PROCUREMENT_PAGE",
        },
      },
    ],
  },

  // BUDGET MODULE

  {
    id: "budget_module",
    path: BUDGET,
    children: [
      {
        id: "budget_list",
        index: true,
        element: <AnnualBudgetPlan />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_BUDGET_PAGE",
        },
      },
      {
        id: "details_annualBudgetPlan",
        path: DETAILS,
        children: [
          {
            id: "details_annualBudgetPlan_noMatch",
            index: true,
            element: <NoMatch />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
              access: "INVENTORY_BUDGET_PAGE",
            },
          },
          {
            id: "details_annualProcurementPlan_list",
            path: ID,
            children: [
              {
                id: "details_annualProcurementPlan_package",
                index: true,
                element: <AnnualBudgetPlanDetails />,
                redirection: <NoMatch />,
                permissions: {
                  auth: ["token"],
                  access: "INVENTORY_BUDGET_PAGE",
                },
              },
              {
                id: "details_annualProcurementPlan_package_edit",
                path: ID_2,
                element: <AddNewPackage />,
                redirection: <NoMatch />,
                permissions: {
                  auth: ["token"],
                  access: "INVENTORY_BUDGET_PAGE",
                },
              },
            ],
          },
        ],
      },
    ],
  },

  // FORECASTING MODULE
  {
    id: "forecasting_module",
    path: FORECASTING,
    children: [
      {
        id: "forecasting_list",
        index: true,
        element: <ForecastingList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_FORECASTING_PAGE",
        },
      },
    ],
  },

  // REQUISITION MODULE
  {
    id: "requisition_module",
    path: REQUISITION,
    children: [
      {
        id: "requisition_list",
        index: true,
        element: <RequisitionList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "requisition_create",
        path: CREATE,
        element: <CreateRequisition />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "requisition_details",
        path: ID,
        element: <RequisitionDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  // ROOM MODULE
  // ROOM CONFIGURATION

  {
    id: "room_configuration",
    path: ROOM_CONFIGURATION,
    children: [
      {
        id: "room_configuration_list",
        path: ROOM_CONFIGURATION,
        element: <InventoryRoomConfiguration />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "INVENTORY_ROOM_PAGE",
        },
      },
    ],
  },

  // CONFERENCE ROOM
  {
    id: "conference_room",
    path: CONFERENCE_ROOM,
    children: [
      {
        id: "conference_room_list",
        index: true,
        element: <RoomConference />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "conference_room_create",
        path: CREATE,
        element: <CreateRoomConference />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "conference_room_details",
        path: ID,
        element: <RoomConferenceDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  // warranty

  {
    id: "warranty",
    path: WARRANTY,
    element: <Warranty />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
      access: "INVENTORY_WARRANTY_PAGE",
    },
  },

  // maintenance

  {
    id: "maintenance",
    path: MAINTENANCE,
    children: [
      {
        id: "maintenance_list",
        index: true,
        element: <Maintenance />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          // access: "INVENTORY_MAINTENANCE_PAGE",
        },
      },
      {
        id: "create_maintenance_list",
        path: CREATE,
        element: <CreateMaintenance />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          // access: "INVENTORY_MAINTENANCE_CREATE_PAGE",
        },
      },
      {
        id: "create_maintenance_list",
        path: ID,
        element: <MaintenanceDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          // access: "INVENTORY_MAINTENANCE_PAGE",
        },
      },
    ],
  },

  // SETTINGS MODULE
  {
    id: "settings",
    path: SETTINGS,
    element: <Settings />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
      access: "INVENTORY_SETTINGS_PAGE",
    },
  },

  // software inventory

  {
    id: "software_inventory",
    path: SOFTWARE_INVENTORY,
    children: [
      {
        id: "software_inventory_list",
        index: true,
        element: <SoftwareInventory />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "create_software_inventory_list",
        path: CREATE,
        element: <SoftwareInventoryForm />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },

      {
        id: "create_software_inventory_list",
        path: ID,
        element: <SoftwareInventoryForm />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },
];
